<template>
  <div class="header-breadcrumbs-tablet screen">
    <div class="bread_crumbs-3">
      <Link01 />
      <Division />
      <Link02 :player="player" />
      <Division />
      <ActualSection />
    </div>
    <header class="header-2">
      <div class="header_container-2">
        <div class="player_data-2">
          <div class="photo-club-3" v-if="player.player_photo">
            <div class="foto_-container-3">
              <img class="foto_jugador-3" :src="player.player_photo" alt="foto_jugador" /><img
                class="foto_club-3"
                :src="player.team_logo"
                alt="foto_club"
              />
            </div>
          </div>
          <div class="info-2" v-if="player.player_photo">
            <div class="info_container-2">
              <div class="name-3">
                <h1 class="title valign-text-middle">{{ playerName }}</h1>
              </div>
              <div class="container_info-2">
                <NationalityAge :countryFlag="player.flag" :player="player" />
              </div>
            </div>
          </div>
        </div>
        <div class="header_info_menu-2">
          <div class="btn_posesion" :class="value === 4 ? 'active' : ''" @click="onChangeSection(4)">
            <img
              class="icn_resumen"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen@2x.png"
              alt="icn_resumen"
            />
            <div class="resumen-2 valign-text-middle avenirnextltpro-demi-normal-white-6px">RESUMEN</div>
          </div>
          <div
            v-on:mouseover="isHover = true"
            v-on:mouseleave="isHover = false"
            class="btn_posesion"
            :class="value === 1 ? 'active' : ''"
            @click="onChangeSection(1)"
          >
            <img
              v-if="!isHover && value != 1"
              class="icn_posesion-1"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_normal@2x.png"
              alt="icn_posesion"
            />
            <img
              v-else
              class="icn_posesion-1"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_hover@2x.png"
            />
            <div class="posesin-2 valign-text-middle avenirnextltpro-demi-normal-white-6px">POSESIÓN</div>
          </div>
          <div class="btn_posesion" :class="value === 2 ? 'active' : ''" @click="onChangeSection(2)">
            <img
              class="icn_posesion-1"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_ofensivo@2x.png"
              alt="icn_posesion"
            />
            <div class="posesin-2 valign-text-middle avenirnextltpro-demi-normal-white-6px">OFENSIVO</div>
          </div>
          <div class="btn_posesion" :class="value === 3 ? 'active' : ''" @click="onChangeSection(3)">
            <img
              class="icn_posesion-1"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_defensivo@2x.png"
              alt="icn_posesion"
            />
            <div class="posesin-2 valign-text-middle avenirnextltpro-demi-normal-white-6px">DEFENSIVO</div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import playerHeaderMixin from '@/utils/mixins/player-header';
import Link01 from '@/components/Sections/HeaderFigma/Link01';
import Division from '@/components/Sections/HeaderFigma/Division';
import Link02 from '@/components/Sections/HeaderFigma/Link02';
import ActualSection from '@/components/Sections/HeaderFigma/ActualSection';
import NationalityAge from '@/components/Sections/HeaderFigma/NationalityAge';
export default {
  name: 'HeaderBreadcrumbsTablet',
  components: {
    Link01,
    Division,
    Link02,
    ActualSection,
    NationalityAge,
  },
  props: {
    player: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      isHover: false,
      section: 4,
      sections: [
        {
          id: 4,
          title: 'analysis_type.summary',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen_unselected.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen.svg',
          ],
          selected: false,
        },
        {
          id: 1,
          title: 'analysis_type.possession',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-white.svg',
          ],
          selected: false,
        },
        {
          id: 2,
          title: 'analysis_type.offensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-white.svg',
          ],
          selected: false,
        },
        {
          id: 3,
          title: 'analysis_type.defensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-white.svg',
          ],
          selected: false,
        },
      ],
    };
  },
  mounted() {
    this.changeSection(this.value);
  },
  computed: {
    sectionsIds() {
      return this.sections.map(i => i.id);
    },
  },
  methods: {
    changeSection(sectionId) {
      if (this.sectionsIds.includes(sectionId)) {
        this.sections.forEach(e => (e.selected = false));
        const section = this.sections.find(s => s.id === sectionId);
        if (section) {
          section.selected = true;
          return true;
        }
      }
      return false;
    },
    onChangeSection(id) {
      this.section = id;
      let result = this.changeSection(id);
      if (result) this.$emit('input', id);
    },
  },
  watch: {
    value(newId) {
      this.changeSection(newId);
    },
  },
  mixins: [playerHeaderMixin],
};
</script>

<style scoped lang="css">
.headerfigma .active {
  background-color: #23b0ff !important;
}
.headerfigma .header-breadcrumbs-tablet {
  align-items: center;
  border: 1px none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -10px;
  min-width: 100%;
  position: relative;
}

.headerfigma .bread_crumbs-3 {
  align-items: center;
  align-self: stretch;

  justify-content: left;
  display: flex;
  padding: 0px 0px 0px 4px;
  position: relative;
}

.headerfigma .header-2 {
  align-items: center;
  align-self: stretch;
  background: linear-gradient(
    180deg,
    rgb(6.85, 91.11, 137.06) 0%,
    rgba(1.63, 68.84, 105.5, 1) 51.8%,
    rgba(1.42, 14.25, 21.25, 1) 100%
  );
  background-color: transparent;
  border-radius: 8.2px;
  display: flex;
  gap: 4.82px;
  height: 95px;
  mix-blend-mode: normal;
  padding: 4px 12px 6.75px;
  position: relative;
}

.headerfigma .header_container-2 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  justify-content: space-between;
  position: relative;
}

.headerfigma .player_data-2 {
  align-items: flex-start;
  display: flex;
  gap: 14px;
  position: relative;
  width: fit-content;
}

.headerfigma .photo-club-3 {
  height: 65.31px;
  min-width: 62.44px;
  position: relative;
}

.headerfigma .foto_-container-3 {
  height: 66px;
  left: -3px;
  position: relative;
  width: 66px;
}

.headerfigma .foto_jugador-3 {
  height: 61px;
  left: 24px;
  object-fit: cover;
  position: absolute;
  top: 5px;
  width: 43px;
  border-radius: 6.1px;
  border: solid 2.5px #7ed321;
}

.headerfigma .foto_club-3 {
  height: 28px;
  left: 10px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 28px;
}

.headerfigma .info-2 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4.82px;
  height: 70.2px;
  justify-content: center;
  padding: 2px 0px 0px;
  position: relative;
  width: auto;
}

.headerfigma .info_container-2 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4.2px;
  position: relative;
}

.headerfigma .name-3 {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  padding: 3px 0px;
  position: relative;
  width: fit-content;
}

.headerfigma .title {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xxxxl);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1px;
  position: relative;
  text-shadow: 0px 1.93px 1.93px #162b3436;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .container_info-2 {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 7.23px;
  position: relative;
}

.headerfigma .header_info_menu-2 {
  align-items: center;
  align-self: stretch;
  border-radius: 5.79px;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
  position: relative;
  width: fit-content;
}

.headerfigma .btn_resumen-2 {
  align-items: center;
  /* background-color: var(--dodger-blue); */
  border-radius: 5.3px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  padding: 5px 0px;
  position: relative;
  width: 72px;
}

.headerfigma .btn_posesion:hover {
  background-color: #23b0ff;
  cursor: pointer;
}

.headerfigma .icn_resumen {
  height: 23.63px;
  min-width: 23.63px;
  position: relative;
}

.headerfigma .resumen-2,
.headerfigma .posesin-2 {
  letter-spacing: -0.18px;
  line-height: 4px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigma .btn_posesion {
  align-items: center;
  border-radius: 5.3px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  padding: 5px 0px;
  position: relative;
  width: 72px;
  box-shadow: 0 0.9px 4.7px 0 rgba(27, 45, 63, 0.14);
  border: solid 0.9px #23b0ff;
}

.headerfigma .icn_posesion-1 {
  height: 23.63px;
  min-width: 37.16px;
  position: relative;
}
</style>
